import { render, staticRenderFns } from "./UserCostManager2.vue?vue&type=template&id=83989060&scoped=true&"
import script from "./UserCostManager2.vue?vue&type=script&lang=js&"
export * from "./UserCostManager2.vue?vue&type=script&lang=js&"
import style0 from "./UserCostManager2.vue?vue&type=style&index=0&id=83989060&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83989060",
  null
  
)

export default component.exports